import { update } from "../action-types";

const updateBook = (id, updated) =>{
    return async (dispatch) => {
        const responce = await fetch(`http://localhost:9000/books/${id}`,{
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(updated)
        });
        const updatedBook = await responce.json();

        dispatch(update(updatedBook.id, updatedBook))
    }
}
export default updateBook;